



























/**
 * ラジオボタン、初期値が設定されないVueの特性？を回避できてない
 */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Label from './Label.vue';
import ErrorField from './ErrorField.vue';
import { Validable } from './Validable';

@Component({ components: { Label, ErrorField } })
export default class RadioGroup extends Vue implements Validable {
  @Prop()
  title!: string;

  @Prop()
  options!: { title: string; value: string }[];

  @Prop({ default: false })
  required!: boolean;

  // 0 = full
  @Prop({ default: 0 })
  limit!: number;

  @Prop()
  value!: string;

  @Prop({ default: false })
  forDisplay!: boolean;

  checkedItem = '';

  get displayValue() {
    return this.checkedItem;
  }

  error = '';

  onInput() {
    this.validation();
    console.log('radio onin', this.checkedItem);
    this.$emit('input', this.checkedItem);
  }

  get dispOptions() {
    return this.options.map((o) => {
      return { title: o.title, value: o.value };
    });
  }

  @Watch('value')
  inValue() {
    this.checkedItem = this.value;
    console.log('radio ', this.checkedItem);
  }

  validation(): { hasErrors: boolean; messages: string[] } {
    const errors: string[] = [];
    if (this.required && !this.checkedItem) {
      errors.push(`${this.title}は必ず入力してください`);
    }
    this.error = errors.join('<br>');
    return { hasErrors: this.error ? true : false, messages: errors };
  }
}
